<template>
  <div id="header">
    <van-row>
      <van-col span="6">
        <div id="logo">
          <img src="../assets/logo.png">
        </div>
      </van-col>
      <van-col span="18">
        <div id="header-info">
          {{headerText}}
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    name: 'VHeader',
    data () {
      return {
        headerText:'海容冷链访客预约'
      }
    },
  }

</script>

<style scoped>
  #header {
    background: linear-gradient(135deg, #2283EB, #1565C0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 8px 0;
  }

  #logo {
    margin-left: 16px;
    line-height: 40px;
    padding: 4px 0;
    transition: transform 0.3s ease;
  }

  #logo:hover {
    transform: scale(1.05);
  }

  #logo img {
    width: 100%;
    max-width: 120px;
    height: auto;
  }

  #header-info {
    text-align: left;
    line-height: 48px;
    color: white;
    font-size: 1.2em;
    font-weight: 500;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
    padding-left: 8px;
  }

  @media screen and (max-width: 768px) {
    #header-info {
      font-size: 1em;
      line-height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/VHeader.vue